export default "__VITE_ASSET__kFkXbJFq__"